import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges} from '@angular/core';
import {SalesConciergeRequest} from '../../../models/sales-concierge-request.model';
import {SalesConciergeStep} from '../../../enums/sales-concierge-step.enum';
import {SalesConciergeRequestType} from '../../../enums/sales-concierge-request-type.enum';
import {SalesConciergeContactType} from '../../../enums/sales-concierge-contact-type.enum';

@Component({
    selector: 'sales-concierge-request-type',
    templateUrl: './request-type.component.html',
    styleUrls: ['./request-type.component.scss']
})
export class SalesConciergeRequestTypeComponent implements OnChanges {


    @Input() public salesConciergeRequest: SalesConciergeRequest;
    @Input() reset = false;
    @Output() salesConciergeNextStep = new EventEmitter<SalesConciergeStep>();

    @Output()
    public selectedSalesConciergeRequest: EventEmitter<SalesConciergeRequest> = new EventEmitter<SalesConciergeRequest>();
    public salesConciergeRequestType = SalesConciergeRequestType;
    public selectedRequestTypeIndex = -1;

    public otherIssueMessage = null;

    public constructor() {
        this.salesConciergeRequest = new SalesConciergeRequest();

    }

    public returnZero() {
        return 0;
    }


    public ngOnChanges(change: SimpleChanges) {
        if (change['reset'] && change['reset'].currentValue) {
            this.selectedRequestTypeIndex = -1;

        }


    }

    public getKeyByValue(EnumType: Object, value: any): string {
        return Object.keys(EnumType).find(key => EnumType[key] === value);
    }


    public setOtherIssuesMessage(message: string) {
        this.salesConciergeRequest.otherIssuesMessage = message;
        this.otherIssueMessage = message;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);

    }

    public setRequestType(index: number, typeValue: string) {


        const key = this.getKeyByValue(SalesConciergeRequestType, typeValue);
        // this.salesConciergeRequest = new SalesConciergeRequest();
        this.salesConciergeRequest.requestType = key;
        this.salesConciergeRequest.contactType = this.getKeyByValue(SalesConciergeContactType, SalesConciergeContactType.EXISTING_CONTACT_INFO);

        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);

        this.selectedRequestTypeIndex = index;
        if (SalesConciergeRequestType[key] === SalesConciergeRequestType.NEW_ACQUISITION) {


            this.salesConciergeNextStep.emit(SalesConciergeStep.PRODUCT_COUNT_INFO);
        }


    }

}
